import { EVENTS } from './events.js';
import { addToCart, getCart } from './cart.js';
import './embedded-care-guide.js';
import './embedded-product.js';
import './embedded-quiz.js';

const handleAutoAddGwp = async () => {
  const autoAddSaleCampaigns = window.__autoAddSaleCampaigns__;

  if (!autoAddSaleCampaigns?.length) {
    return;
  }

  const cart = await getCart()

  const cartTotal = cart.total_price / 100;
  const {
    cartThreshold, minPurchaseQuantity, variantId, variantQuantity, applicableProductTypes,
  } = autoAddSaleCampaigns[0];
  let autoAddApplicable = false;
  const itemAlreadyInCart = cart.items.find((
    cartItem
  ) => cartItem.variant_id === variantId);

  if (itemAlreadyInCart) {
    return;
  }

  if (cartThreshold) {
    if (cartTotal >= cartThreshold) {
      autoAddApplicable = true;
    }
  } else if (minPurchaseQuantity) {
    let currentApplicableItemsQuantity = 0;

    cart.items.forEach((item) => {
      if (applicableProductTypes.includes(item.product_type)) {
        currentApplicableItemsQuantity += item.quantity;
      }
    });

    if (currentApplicableItemsQuantity >= minPurchaseQuantity) {
      autoAddApplicable = true;
    }
  }

  if (autoAddApplicable) {
    await addToCart({
      items: [
        {
          id: variantId,
          quantity: variantQuantity || 1
        }
      ]
    });

    document.dispatchEvent(new CustomEvent('cart:build'));
  }
};

const initAutoAddSaleCampaigns = () => {
  document.addEventListener(EVENTS.ajaxProductAdded, handleAutoAddGwp);
}

const init = () => {
  initAutoAddSaleCampaigns();
};

init();